import { notification } from '@pu/mpp-ui/notifications';
import { IUpsertBranchParams } from 'core/model/interfaces/distributors/branches.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { SLICE_NAMESPACE } from '../../constants';
import { IDistributorsState } from '../../types';

export const updateBranch = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/updateBranch`,
  async (data: IUpsertBranchParams) => {
    try {
      await apiService.branches.updateBranch(data);

      notification.success('Se guardaron los cambios correctamente.');
    } catch (error) {
      const errorMessage = handleErrorMessage(error, 'Falló al guardar los cambios.');

      showNotificationError(errorMessage);

      throw error;
    }
  },
);

export const updateBranchReducer: TSliceExtraReducer<IDistributorsState> = builder =>
  builder
    .addCase(updateBranch.pending, state => {
      state.branchesList.form.loading = true;
      state.branchesList.form.success = false;
      state.branchesList.form.errors = {};
    })
    .addCase(updateBranch.rejected, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = false;
    })
    .addCase(updateBranch.fulfilled, state => {
      state.branchesList.form.loading = false;
      state.branchesList.form.success = true;
      state.branchesList.form.errors = {};
    });
